import { Formik } from 'formik';

import { Messages } from 'config';
import { ButtonColors } from 'types';
import { formatDate } from 'utils/date';
import { UpdateChargebackRequest } from 'store/api/accounting';
import {
  Col,
  Row,
  Button,
  FormFooter,
  ButtonTypes,
  CommonStyles,
  DatePickerField,
} from 'components';

import { FormProps } from './types';
import { getInitialValues, validationSchema } from './config';

export const Form = ({
  data,
  update,
  mobile,
  onClose,
  showSuccessAlert,
}: FormProps) => (
  <Formik
    enableReinitialize
    validationSchema={validationSchema}
    initialValues={getInitialValues(data)}
    onSubmit={async (values, { resetForm }) => {
      const response = await update({
        ...values,
        id: data!.id,
        responseDate: formatDate(values.responseDate),
      } as UpdateChargebackRequest).unwrap();
      if (response.id) {
        showSuccessAlert(`Chargeback ${Messages.UPDATED_SUCCESSFULLY}`);
        resetForm();
        onClose?.();
      }
    }}
  >
    {({ dirty, isSubmitting }) => (
      <CommonStyles.Form>
        <Row>
          <Col col={6}>
            <DatePickerField
              name="responseDate"
              label="Response Date"
              placeholderText="Select Date"
            />
          </Col>
        </Row>

        <FormFooter
          right={
            <CommonStyles.FormButtons>
              <Button
                text="Cancel"
                onClick={onClose}
                fullWidth={mobile}
                colorType={ButtonColors.LightBlue}
              />
              <Button
                text="Save"
                fullWidth={mobile}
                type={ButtonTypes.Submit}
                disabled={!dirty || isSubmitting}
              />
            </CommonStyles.FormButtons>
          }
        />
      </CommonStyles.Form>
    )}
  </Formik>
);
